import React, { useEffect, useState } from "react";
import TfStyle from "./tf.module.css";
import { Form, Input, Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
const { TextArea } = Input;
function TF() {
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const onFinish = (value) => {
    console.log(value);
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
      console.log(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      gene_id_text: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);
  return (
    <div className={TfStyle.Tf_app}>
      {/* <div className={TfStyle.Tf_Header}>
        <p>Tools/TF Pridect</p>
      </div>
      <div className={TfStyle.Tf_Formdiv}>
        <div className={TfStyle.Tf_Formdiv_header}>
          <p>TF Prediction</p>
        </div>
        <div className={TfStyle.Tf_Formdiv_header2}>
          <p>Please create a project and enter the nucleic acid sequence, select the variety you want to predict, and we will provide you with the results of predicting transcription factors</p>
          <p>
            Input protein or nucleic acid sequences in FASTA format(Max file
            size:75M): example
          </p>
        </div>
        <Form form={form} onFinish={onFinish} style={{ margin: "10px 0" }}>
          <Form.Item name="gene_id_text">
            <TextArea style={{ height: 150 }} />
          </Form.Item>
          <Form.Item
            name="SN"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            style={{
              width: "60%",
            }}
          >
            <Upload
              beforeUpload={contentUpload}
              name="SN"
              action="/upload.do"
              onRemove={() => {
                setFileContent("");
              }}
            >
              <Button
                style={{
                  border: "none",
                  padding: "0",
                  margin: "0",
                  background: "transparent",
                }}
                icon={<UploadOutlined />}
              >
                Click to upload
              </Button>
            </Upload>
          </Form.Item>
          <Form.Item
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Button
              style={{
                margin: "0 20px",
                border: "none",
                background: "#B886F8",
              }}
            >
              Prediction
            </Button>
            <Button
              style={{
                margin: "0 20px",
                border: "none",
                background: "#B886F8",
              }}
              onClick={()=>{
                form.resetFields()
                setFileContent("")
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div> */}
      <iframe src="https://planttfdb.gao-lab.org/prediction.php" 
      style={{width:"100%", height: "80vh"}}
      frameborder="0"></iframe>
    </div>
  );
}

export default TF;
